'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NEW_DISPLAY_SETTINGS = exports.NEW_DISPLAY_SETTINGS = 'Chatflows:NewDisplaySettings';

var LIVECHAT_CMF = exports.LIVECHAT_CMF = 'Conversations:dev:livechat-cmf';

var INITIAL_MESSAGE = exports.INITIAL_MESSAGE = 'Conversations:InitialMessage';

var LIVECHAT_UTV = exports.LIVECHAT_UTV = 'Conversations:LiveChatUTV';